const FileStorageConfigurationController = function ($scope, $http, FileStorageConfiguration) {
    
    const loadFileStorageConfiguration = function () {
        if ($scope.adminOrInRole([])) {
            $scope.fileStorageConfiguration = FileStorageConfiguration.query();
            $http.get('/api/v1/fileStorageConfiguration/storageProviders').then(function (response) {
                $scope.fileStorageProviders = response.data;
            });
        }
    }
    
    loadFileStorageConfiguration();

    $scope.saveAndValidateAmazonS3Settings = function () {
        $http.put('/api/v1/fileStorageConfiguration/amazonSettings', $scope.fileStorageConfiguration.AmazonS3Settings)
            .success(function () {
                $scope.notify("success", "Saved successfully.");
                $scope.fileStorageConfiguration = FileStorageConfiguration.query();
            }).error(function () {
            $scope.fileStorageConfiguration = FileStorageConfiguration.query();
        });
    }
    
    $scope.saveFileTypeStorageSettings = function () {
        $http.put('/api/v1/fileStorageConfiguration/fileTypeStorageSettings', $scope.getFileTypeStorageConfiguration())
            .then(function () {
                $scope.notify("success", "Saved successfully.");
            });
    }

    $scope.getFileTypeStorageConfiguration = function () {
        return {
            'FileStorageByFileType' : $scope.fileStorageConfiguration.FileStorageByFileType,
            'MirrorToDefaultFileStorage' : $scope.fileStorageConfiguration.MirrorToDefaultFileStorage,
            'PrimaryReadStorageProvider' : $scope.fileStorageConfiguration.PrimaryReadStorageProvider 
        };
    }
    
    $scope.IsFileStorageSettingsValid = function (fileType) {
        
        if(fileType === 'S3Bucket')
        {
            return $scope.fileStorageConfiguration.AmazonS3Settings.IsValid;
        }
        
        return true;
    }

};
FileStorageConfigurationController.$inject = ["$scope", "$http", "FileStorageConfiguration"];

angular.module('globalControllers',)
       .controller('FileStorageConfigurationController', FileStorageConfigurationController);
